//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('findPerson', {
//        templateUrl: 'views/components/views/findPerson/findPerson.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'findPersonService', 'incomingCallService', 'rememberService', function (stateService, utilityService, findPersonService, incomingCallService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchButtons: [
//                    { id: 'erase', icon: 'fas fa-eraser', type: 'danger', color: 'danger', onClick: () => clear('searchtext') },
//                    { id: 'search', icon: 'fas fa-search', type: 'primary', color: 'primary', onClick: () => searchItems() }
//                ],
//                setting: {},
//                itemsListFindPersons: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function doInitialSearch() {
//                vm.model.setting = (await findPersonService.getSetting())[0];
                
//                if (vm.model.setting.searchtext > '') loadFindPersons();
//            }

//            async function loadFindPersons() {
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                return vm.model.itemsListFindPersons = await incomingCallService.listFindPersons(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';
//                        vm.model.itemsListFindPersons = [];

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region SEARCH FUNCTIONS

//            function searchItems() {
//                return Promise.all([
//                    rememberFunc('searchtext')
//                ]).then(() => {
//                    loadFindPersons();
//                    Promise.resolve();
//                });

//                return Promise;
//            }

//            vm.searchItems = searchItems;

//            // #endregion SEARCH FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') clear('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

//                        if (vm.model.setting.searchtext > '') searchItems();
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region ANGULAR LIFECYCLE FUNCTION

//            vm.$onInit = function () {
//                doInitialSearch();
//            }

//            // #endregion ANGULAR LIFECYCLE FUNCTION

//        }]
//    });
//})();
